import { PAYMENT_STEP_TYPE } from 'config'

const isUpgradeType = (paymentStepType) => {
  return [
    PAYMENT_STEP_TYPE.MEMBERSHIP_UPGRADE,
    PAYMENT_STEP_TYPE.TRAILER_CARE_UPGRADE,
  ].includes(paymentStepType)
}

export default isUpgradeType
